import { Capacitor } from '@capacitor/core';
import axios from 'axios';

export const collectDeferredDeviceData = () => ({
  language: navigator.language || '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
  platform: navigator.platform || '',
  screen_width: window.screen?.width || window.innerWidth || null,
  screen_height: window.screen?.height || window.innerHeight || null,
  user_agent: navigator.userAgent || ''
});

export const resolveDeferredDeepLink = () => {
  if (Capacitor.getPlatform() === 'web') {
    return Promise.resolve({ matched: false });
  }

  return axios
    .post(
      '/public/deferred_deep_link/resolve',
      {
        device: collectDeferredDeviceData()
      },
      {
        baseURL:
          process.env.VUE_APP_URL_API ?? import.meta.env.VITE_APP_URL_API,
        headers: {
          from:
            process.env.VUE_APP_FROM_PROJECT ??
            import.meta.env.VITE_APP_FROM_PROJECT,
          originalFrom:
            process.env.VUE_APP_FROM_PROJECT ??
            import.meta.env.VITE_APP_FROM_PROJECT,
          'Accept-Language': localStorage?.locale ?? 'ru'
        }
      }
    )
    .then((response) => response.data);
};
